import {Link} from "react-router";
import {Card, CardBody} from "@nextui-org/card";
import React, {useEffect} from "react";
import blogAnimation from "../../utils/blogSectionAnimation";

export const BlogCard = (props) => {

    useEffect(() => {
        const mq = window.matchMedia("(min-width: 1024px)");
        if (mq.matches) {
            blogAnimation.desktopAnimation();
        } else {
            blogAnimation.mobileAnimation();
        }
    }, []);

    const post = props.blogPost;

    return (
        <Card className="col-span-full lg:row-start-1 lg:row-span-1 lg:col-span-1 mobile-animation blogCard mb-5">
            <svg
                xmlns="http://www.w3.org/2000/svg"
                className="hidden lg:block icon icon-tabler icon-tabler-timeline absolute top-0 -right-7 stroke-green-100 dark:stroke-zinc-800"
                width="200"
                height="200"
                viewBox="0 0 24 24"
                strokeWidth="2"
                fill="none"
                strokeLinecap="round"
                strokeLinejoin="round"
            >
                <path
                    stroke="none"
                    d="M0 0h24v24H0z"
                    fill="none"
                ></path>
                <path d="M4 16l6 -7l5 5l5 -6"></path>
                <path d="M15 14m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"></path>
                <path d="M10 9m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"></path>
                <path d="M4 16m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"></path>
                <path d="M20 8m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"></path>
            </svg>
            <CardBody className="dark:text-gray-400 text-gray-700 text-lg flex justify-between gap-4 p-5">
                <div className="flex justify-between items-center">
                    <span className="font-light text-gray-600 dark:text-gray-100">{post.date}</span>
                </div>
                <div className="mt-2 text-start">
                    <Link to={`/blog/${post.id}`} className="text-2xl text-gray-700 dark:text-gray-100 font-bold hover:underline" aria-label={post.title}>{post.title}</Link>
                    <p className="mt-2 text-gray-600 dark:text-gray-100">{post.body}</p>
                </div>
                <div className="flex justify-between items-center mt-4">
                    <Link to={`/blog/${post.id}`} className="text-green-700 dark:text-blue-300 hover:underline font-medium" aria-label={post.title}>Read the full article</Link>
                </div>
            </CardBody>
        </Card>
    )
}
